/**
 * Created by Bart Decorte
 * Date: 02/10/2018
 * Time: 17:25
 */
import EntriesEdit from './pages/Entries/EntriesEdit';
import HomeIndex from './pages/Home/HomeIndex';
import TablesEdit from './pages/Tables/TablesEdit';
import TablesShowGallery from './pages/Tables/TablesShowGallery';
import TablesShowInline from './pages/Tables/TablesShowInline';
import TablesShowList from './pages/Tables/TablesShowList';
import WebsitesEdit from './pages/Websites/WebsitesEdit';
import WebsitesShow from './pages/Websites/WebsitesShow';
import WebsitesGenerate from './pages/Websites/WebsitesGenerate';
import EntriesFiles from './pages/Entries/EntriesFiles';
import EntriesImages from './pages/Entries/EntriesImages';
import UsersEdit from './pages/Users/UsersEdit';
import UsersAdd from './pages/Users/UsersAdd';
import UsersCreate from './pages/Users/UsersCreate';
import UsersIndex from './pages/Users/UsersIndex';
import LogsIndex from './pages/Logs/LogsIndex';
import AuthLogin from './pages/Auth/AuthLogin';
import WebsitesToolsIndex from './website-tools/ToolsIndex';
import WebsitesToolsFindReplaceIndex from './website-tools/find-replace/FindReplaceIndex';
import WebsitesToolsBatchImageResizeIndex from './website-tools/batch-image-resize/BatchImageResizeIndex';
import WebsitesToolsSlugGenerateIndex from './website-tools/slug-generate/SlugGenerateIndex';
import InsightsIndex from './pages/Insights/InsightsIndex';
import QuestionsIndex from './content/QuestionsIndex';
import QuestionsShow from './content/QuestionsShow';
import AppsIndex from './pages/Apps/AppsIndex';
import AppsEdit from './pages/Apps/AppsEdit';
import AppsToken from './pages/Apps/AppsToken';
import AppsAuthorize from './pages/Apps/AppsAuthorize';
import UsersApps from './pages/Users/UsersApps';
import ToolsIndex from './tools/ToolsIndex';
import ToolsConnectionCheckIndex from './tools/connection-check/ConnectionCheckIndex';
import trackingEvents from './tracking-events/trackingEvents';

trackingEvents();

(() => {
  const classes = {
    EntriesEdit,
    EntriesFiles,
    EntriesImages,
    HomeIndex,
    TablesEdit,
    TablesShowGallery,
    TablesShowInline,
    TablesShowList,
    WebsitesEdit,
    WebsitesShow,
    WebsitesGenerate,
    UsersEdit,
    UsersAdd,
    UsersCreate,
    UsersIndex,
    LogsIndex,
    WebsitesToolsBatchImageResizeIndex,
    WebsitesToolsIndex,
    WebsitesToolsFindReplaceIndex,
    InsightsIndex,
    QuestionsIndex,
    QuestionsShow,
    AppsIndex,
    AppsEdit,
    AppsToken,
    WebsitesToolsSlugGenerateIndex,
    AppsAuthorize,
    UsersApps,
    ToolsConnectionCheckIndex,
    ToolsIndex,
    AuthLogin,
  };

  let bodyClass = $('body')
    .attr('class')
    .split(' ');

  let i, className;
  for (i = 0; i < bodyClass.length; i++) {
    className = bodyClass[i].replace(/-([a-z])/g, (g) => {
      return g[1].toUpperCase();
    });
    className = className.charAt(0).toUpperCase() + className.slice(1);

    if (typeof classes[className] !== typeof undefined) {
      new classes[className]();
    }
  }
})();



// WEBPACK FOOTER //
// ./resources/assets/js/app.js